import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RolesEnum } from 'src/app/service/enums/role.enum';
import { LoaderService } from 'src/app/service/loader.service';
import { RdcprimaryDataService } from 'src/app/service/rdcprimary-data.service';
import { RdcPrimaryDataFilterPopupComponent } from 'src/app/shared/components/controls/rdc-primary-data-filter-popup/rdc-primary-data-filter-popup.component';
import { BaseComponent } from 'src/app/shared/components/base.component';
import { DataTableDirective } from 'angular-datatables';
import * as XLSX from 'xlsx';
import { RDCPrimaryDataDto } from 'src/app/model/rdc/RDCPrimaryData';
import { DomSanitizer } from '@angular/platform-browser';
import { FilterDetail } from 'src/app/model/lookup/FilterDetail';

@Component({
  selector: 'app-rdcprimary-data',
  templateUrl: './rdcprimary-data.component.html',
  styleUrls: ['./rdcprimary-data.component.scss']
})
export class RDCPrimaryDataComponent extends BaseComponent implements OnInit {
  dtOptions: any = {};
  rdcprimarydataList: RDCPrimaryDataDto[];
  selectedRoleId: number = 0;
  isSuperAdmin: boolean = false;
  selectedFilters: FilterDetail = new FilterDetail();
  isFilterApplied: boolean = false;

  @ViewChild(DataTableDirective, { static: false })
  private datatableElement: DataTableDirective;
  @ViewChild('dtElement') table: ElementRef;

  constructor(private rdcprimaryDataService: RdcprimaryDataService,
    private loaderService: LoaderService,
    private sanitizer: DomSanitizer,
    private modalService: NgbModal,
  ) {
    super();
    this.isSuperAdmin = this.userProfileService.isRoleExists(RolesEnum.SuperAdmin);

  }


  ngOnInit(): void {
    const that = this;

    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      lengthMenu: [10, 50, 100, 1000],
      serverSide: true,
      processing: true,
      order: [[0, "desc"]],
      dom: 'lBfrtip',
      columns: [
        { orderable: true },
        { orderable: true },
        { orderable: true, },
        { orderable: true, },
        { orderable: true, },
        { orderable: true, },
        { orderable: false, },
        { orderable: false, },
        { orderable: false, },
        { orderable: false, },
        { orderable: false, },
        { orderable: false, },
        { orderable: false, },

      ],
      language: {
        url: 'assets/i18n/' + that.appTranslateService.getCurrentLang() + '.json'
      },
      buttons: [
        {
          text: that.appTranslateService.getTranslate('refresh'),
          key: '1',
          className: 'datatable-export-excel-btn',
          action: (e: Event, dt: any, node: any, config: any) => {
            that.rerender();
          }
        },
        {
          text: that.appTranslateService.getTranslate('exportExcel'),
          key: '2',
          className: 'datatable-export-excel-btn',
          action: (e: Event, dt: any, node: any, config: any) => {
            that.exportToExcel();
          }
        }
      ],
      ajax: (dataTablesParameters: any, callback: any) => {
        dataTablesParameters.selectedRoleId = that.selectedRoleId;
        dataTablesParameters.filters = that.selectedFilters
        that.rdcprimaryDataService.GetRDCPrimaryDataList(dataTablesParameters).subscribe(
          res => {
            if (res.successed) {
              that.rdcprimarydataList = res.data.data
              console.log(" res.data.data", res.data.data);
              console.log("that.rdcprimarydataList",that.rdcprimarydataList);
              callback({
                recordsTotal: res.data.recordsTotal,
                recordsFiltered: res.data.recordsFiltered,
                data: []
              });
              that.loaderService.hide();
            }
            else {
              that.loaderService.hide();
              that.toastrAlertService.errorToastr(res.errorMessage);
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
            }
          },
          error => {
            callback({
              recordsTotal: 0,
              recordsFiltered: 0,
              data: []
            });
            that.loaderService.hide();
            if (typeof error.error !== "undefined") {
              that.toastrAlertService.errorToastr(that.appTranslateService.getTranslate(error.error));
            }
          }
        )

      }
    };



  }

  goToOrderDetails(rdcprimarydata) {
    if (rdcprimarydata.userId === this.userprofile.id || this.userProfileService.isRoleExists(RolesEnum.SuperAdmin)|| this.userProfileService.isRoleExists(RolesEnum.Repaid)) {
      // this.router.navigate(["/order/orderDetails/" + order.requestId]);
      window.open("/order/orderDetails/" + rdcprimarydata.requestId);
    }
  }
  sanitize(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  exportToExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table.nativeElement);

    ws['!cols'] = [];
    ws['!cols'][0] = { hidden: true };

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, this.appTranslateService.getTranslate("rdcPrimaryData"));
    /* save to file */
    XLSX.writeFile(wb, this.appTranslateService.getTranslate("rdcPrimaryData") + '.xlsx');
  }

  rerender() {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.ajax.reload();
    });
  }


  openFilterPopup() {
  
      const modalRef = this.modalService.open(RdcPrimaryDataFilterPopupComponent, { size: 'xl', centered: true, backdrop: 'static', keyboard: false });
      (modalRef.componentInstance as RdcPrimaryDataFilterPopupComponent).selectedFilters = this.selectedFilters;
      modalRef.result.then((result) => {
        console.log(result);
        if (typeof result !== "undefined" && result !== null) {
          if (result.filterApplied === true) {
            this.selectedFilters = result.selectedFilters;
            this.isFilterApplied = true;
          } else {
            this.isFilterApplied = false;
          }
          this.rerender();
        }
  
      });
  
  }

}
